import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// don't want to use this?
// have a look at the Quick start guide 
// for passing in lng and translations on init

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    en: {
        translation: {
            "title": "The Healing Colors",
            "enter": "Discovery it",
            "instructions": "Instructions",
            "step1": "1.- Go to ''COLOR TEST''",
            "step2": "2.- Click on the dotted circle in the lower right to reveal the first color",
            "step3": "3.- Continue clicking the dotted circle until all colors appear.",
            "step4": "4.- Click ''NEXT''",
            "step5": "5.- Starting with the last row, remove the 4 colors you like THE LEAST by clicking on them.",
            "step6": "6.- Repeat with all rows moving from the bottom row towards the top row.",
            "step7": "7.- Click on ''PREVIEW''.",
            "step8": "8.- Click ''PRINT TEST'' and save as PDF.",
            "step9": "9.- Email it to thehealingcolors@gmail.com",
            "description1": "This Color Test marks the beginning of my personal path, and after using it for years and seeing incredible results, I deepened my knowledge in the world of energy through the use of light and color with Chromotherapy and Chromopuncture. The energetic vibration of colors help us balance physically, mentally, emotionally and spiritually. This overall balance is the true definition of health and happiness, and any step we take to achieve it can only make us feel better.",
            "description2": "The Color Test allows us to express ourselves using the universal language of color. It is such an easy and joyous way to get to know ourselves, that even children are naturally open to it. The test enables an intimate communication with ourselves, providing a deeper understanding of our true selves, our current reality, and life.",
            "description3": "Do you want to try the test? You can write me for further information and to organize your test at thehealingcolors@gmail.com. After taking the test, it is interpreted or read to help you understand what was expressed chromatically. A calculation will also be done to reveal a dominant color whose specific energy can further help you achieve greater balance and understanding. It can be incorporated into your wardrobe, food, and also in breathing exercises and visualizations.",
            "description4": "Thank you and I hope that you too decide to discover the light that you really are!",
            "description5": "Isabel Cristina Roca",
            "description6": "''A single ray of sunlight is enough to eliminate millions of shadows.'' San Francisco de Asis",
            "email": "thehealingcolors@gmail.com",
            "test": "Color Test",
            "next": "Next",
            "reset": "Reset",
            "preview": "Preview",
            "choose": "Choose your colors",
            "print": "Print Test!",
            "removeColor": "Remove 4 colors from each row",
            "firstStep": "First Step",
            "secondStep": "Second Step",

        }
    },
    it: {
        translation: {
            "title": "The Healing Colors",
            "enter": "Scoprilo",
            "instructions": "Istruzioni",
            "step1": "1.- Vai a ''TEST DEL COLORE''",
            "step2": "2.- Clicca sul cerchio punteggiato in basso a destra per rivelare il primo colore.",
            "step3": "3.- Continua a fare clic suI cerchio punteggiato che compare fino a rivelare tutti i colori.",
            "step4": "4.- Fai clic su AVANTI.",
            "step5": "5.- Partendo dalla riga in basso, rimuovi i 4 colori che ti piacciono DI MENO cliccando su di essi.",
            "step6": "6.- Ripeti per ogni riga spostandoti verso la sucesiva riga superiore, fino a completare tutte le righe.",
            "step7": "7.- clicca su ''ANTEPRIMA''.",
            "step8": "8.- clicca su ''STAMPA TEST'' e salva il documento como PDF.",
            "step9": "9.- Invialo tramite e-mail a  thehealingcolors@gmail.com",
            "description1": "Questo Test del Colore ha segnato l'inizio del mio percorso di crescita personale e dopo averlo usato per anni, ed aver assistito a risultati incredibili, ho incrementato la mia conoscenza del mondo dell'energia utilizzando la Luce ed i Colori con la Cromoterapia e la Cromopuntura. La vibrazione energetica dei colori ci aiuta ad equilibrarci fisicamente, mentalmente, emotivamente e spiritualmente. Questo equilibrio generale è la vera condizione di salute e felicità. Qualsiasi azione che facciamo per raggiungerlo non può che farci sentire meglio.",
            "description2": "Il Test del Colore ci permette di esprimerci usando il linguaggio universale dei colori. È un modo cosi facile e gioioso per conoscerci meglio che anche i bambini sono naturalmente aperti ad esso. La Prova consente una comunicazione intima con noi stessi, fornendo una comprensione più profonda di noi, della nostra realtà attuale e della vita.",
            "description3": "Voi provare il Test del Colore? Mi puoi scrivere per altre informazioni ed organizare il tuo test a thehealingcolors@gmail.com. Dopo aver sostenuto il Test, leggo i tuoi colori e li interpreto per aiutarti a capire cosa hai espresso cromaticamente. Farò anche un calcolo per rivelare il colore dominante la cui energia specifica ti aiuterà ulteriormente a raggiungere un maggior equilibrio e comprensione di te. Potrai incorporarlo nel tuo guardaroba, nel tuo cibo e anche negli esercizi di respirazione e visualizzazioni.",
            "description4": "Grazie e spero anche tu decida di scoprire la luce che c’è in te!",
            "description5": "Isabel Cristina Roca",
            "description6": "''Un solo raggio di sole è sufficiente per eliminare milioni di ombre''. San Francesco d'Assisi",
            "email": "thehealingcolors@gmail.com",
            "test": "Test del colore",
            "next": "Avanti",
            "reset": "Ripristina",
            "preview": "Anteprima",
            "choose": "Scegli i tuoi colori",
            "print": "Stampare Test!",
            "removeColor": "Rimuovi 4 colori da ogni riga",
            "firstStep": "Primo passo",
            "secondStep": "Secondo passo"

        }
    },
    es: {
        translation: {
            "title": "The Healing Colors",
            "enter": "Descúbrelo",
            "instructions": "Instrucciones",
            "step1": "1.-  Vaya a ''TEST DEL COLOR''.",
            "step2": "2.-  Haga clic en el círculo punteado en la parte inferior derecha para revelar el primer color.",
            "step3": "3.-  Continúe haciendo clic en el círculo punteado hasta que se aparezcan todos los colores.",
            "step4": "4.-  Haga clic en SIGUIENTE.",
            "step5": "5.-  Comenzando con la última fila, elimine los 4 colores que MENOS le gusten haciendo clic en ellos.",
            "step6": "6.-  Repita con cada fila moviéndose desde la fila inferior hacia la fila superior.",
            "step7": "7.-  Haga clic en ''VISTA PREVIA''.",
            "step8": "8.-  Haga clic en ''IMPRIMIR PRUEBA'' y guarde el documento como PDF.",
            "step9": "9.-  Envíelo por correo electrónico a thehealingcolors@gmail.com",
            "description1": "Esta Prueba de Color marca el origen de mi camino de crecimiento personal, y luego de usarlo durante años y ver resultados increíbles, profundicé mi conocimiento en el mundo de la energía mediante el uso de luz y color con la Cromoterapia y Cromopuntura. La vibración energética de los colores nos ayuda a equilibrar física, mental, emocional y espiritualmente. Este equilibrio general es la verdadera definición de salud y felicidad, y cualquier paso que tomemos para lograrlo solo puede hacernos sentir mejor.",
            "description2": "La Prueba de Color nos permite expresarnos utilizando el lenguaje universal de los colores. Es un modo tan fácil y alegre de conocernos mejor, que incluso los niños están naturalmente abiertos a ello. La prueba permite una comunicación íntima con nosotros mismos, proporcionando una comprensión más profunda de nuestro verdadero yo, nuestra realidad actual y la vida. ",
            "description3": "Quieres hacer la Prueba de Color? Me puedes escribir para más información y organizar tu prueba a thehealingcolors@gmail.com. Después de hacer la prueba, se interpreta o lee para ayudarte a comprender lo que se expresó de manera cromática. También se hará un cálculo para revelar un color dominante cuya energía especifica te ayudará aún más a lograr mayor equilibrio y comprensión. Se puede incorporar en tu guardarropa, comida y también en ejercicios de respiración y visualizaciones.",
            "description4": "¡Gracias y espero que tú también decidas descubrir la luz que realmente eres!",
            "description5": "Isabel Cristina Roca",
            "description6": "''Un solo rayo de sol es suficiente para eliminar millones de sombras''. San Francisco de Asís",
            "email": "thehealingcolors@gmail.com",
            "test": "Test del color",
            "next": "Siguiente",
            "reset": "Reiniciar",
            "preview": "Vista Previa",
            "choose": "Seleccione los colores",
            "print": "Imprimir Test!",
            "removeColor": "Elimine 4 colores de cada fila",
            "firstStep": "Primer paso",
            "secondStep": "Segundo paso",

        }
    },
};

i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    //.use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    // .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        resources,
        lng: 'it',
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        }
    });


export default i18n;